export default __webpack_public_path__ + "static/media/my_investment_icon.6793412a.svg";